import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { transition, animate, style, trigger } from '@angular/animations';
import { CustomerSelectItem, EquipmentSelectItem } from '../../../setup-equipment/setup-equipment.model';
import { GenericIdName } from '../../../setup-implement/setup-implement.model';
import { GETSetupEquipmentService } from '../../../setup-equipment/setup-equipment.service';
import { SetupImplementService } from '../../../setup-implement/setup-implement.service';
import { FECRDashboardSearch, ImplementItem } from './fecr-search-panel.model';
import { MatDialog } from '@angular/material/dialog';import { FavouriteDialogService } from '../../../favourite-dialog/favourite-dialog.service';
import { JobsiteSelectionFilter, ModelSelectionFilter } from '../../../favourite-dialog/favourite-dialog-modal';
import { FrontEndComponetService } from '../../front-end-componet.service';
import { FecrMovetoInventoryComponent } from '../../fecr-moveto-inventory/fecr-moveto-inventory.component';
import { Router } from '@angular/router';

@Component({
  selector: 'fecr-search-panel',
  templateUrl: './fecr-search-panel.component.html',
  styleUrls: ['./fecr-search-panel.component.scss'],
  animations: [
    trigger(
      'fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 0 }),
        animate('0ms', style({ opacity: 0 }))
      ])
    ]
    )]
})
export class FecrSearchPanelComponent implements OnInit {

  // Drop-down lists
  customerList: CustomerSelectItem[] = [];
  jobsiteList: GenericIdName[] = [];
  equipmentList: EquipmentSelectItem[] = [];
  implementTypeList: GenericIdName[] = [];
  repairerList: GenericIdName[] = [];
  familyList: GenericIdName[] = [];
  copyfamilyList: GenericIdName[] = [];
  makeList: GenericIdName[] = [];

  modelList: GenericIdName[] = [];
  implementList: ImplementItem[] = [];
  initialImplementList: ImplementItem[] = [];


  // Search Filters
  selectedCustomer: number[] = [];
  selectedJobsite: number[] = [];
  selectedEquipment: number[] = [];
  selectedImplementType: number[] = [];
  selectedRepairer: number[] = [];
  selectedFamily: number[] = [];
  selectedModel: number[] = [];
  selectedImplement: number[] = [];
 

  preShipped: boolean = true;
  shipped: boolean = true;
  disassembled: boolean = true;
  sow: boolean = true;
  approvals: boolean = true;
  wip: boolean = true;
  readytoShip: boolean = true;
  complete: boolean = false;
  readytoRebuild:boolean=true;


  @Output() searchFilters: EventEmitter<FECRDashboardSearch> = new EventEmitter<FECRDashboardSearch>();

  @Output() Reset: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() selectedTab: number;
  constructor(private _equipmentService: GETSetupEquipmentService,
    private _implementService: SetupImplementService,
    private _fecrService: FrontEndComponetService,private _router: Router,
    public dialog: MatDialog,
    private _favouriteDialogService: FavouriteDialogService) { }

  ngOnInit() {
    this.loadCustomers();
    // this.loadMakes();
    this.loadRepairer();
    this.loadFamilies();
    this.loadImplementsForEquipment();
  }

  // ChangeCheckBox(value:number) {
  //   if(value==1)
  //     this.preShipped=!this.preShipped;
  //   if(value==1)
  //   this.shipped=!this.shipped;
  //   if
  // }
  loadCustomers() {
    this._equipmentService.getCustomerList().subscribe(r => {
      this.customerList = r;
    });
  }

  FilterFamilyForCustomer(){
    if (this.selectedCustomer == null){
        this.familyList = this.copyfamilyList;
    return ;
    }else{
      var params: JobsiteSelectionFilter = {
        Customers: this.selectedCustomer,
      }
      this._favouriteDialogService.GetFamiliesForSelectedCustomers(params).subscribe(r => {
        if(r){
          this.familyList = r;
        }
      });
    }
  
  }


  // Show the list of Jobsites for the selected customer.
  // Also loads the observation lists.
  loadJobsitesForCustomer() {
    if (this.selectedCustomer == null)
      return;
    this.loadImplementTypes();
    this.selectedJobsite = null;
    this.jobsiteList = null;
    this.selectedImplementType = null;


    this.equipmentList = [];

    var params: JobsiteSelectionFilter = {
      Customers: this.selectedCustomer,
    }
    this._favouriteDialogService.GetjobsitesAvailable(params).subscribe(r => {
      if (r) {
        this.jobsiteList = r;
      }
    });
  }

  // Show the list of equipment for the selected jobsite.
  loadEquipmentForJobsite() {
    if (this.selectedJobsite == null)
      return;
    var params: number[] = this.selectedJobsite;
    this._favouriteDialogService.GetEquipmentAvailable(params).subscribe(r => {
      if (r) {
        this.equipmentList = r;
      }
    });
  }

  onSelectImplementType() {
    if (this.selectedImplementType != null) {
      //this._equipmentId = this.selectedEquipment;
      // this.loadImplementsForEquipment();
      console.log("r selectedImplementType__", this.selectedImplementType)
      console.log("r this.implementList__", this.initialImplementList)

      if (this.selectedImplementType.length > 0) {
        let arr = []
        this.selectedImplementType.map(m => {
          let filterUsingType = this.initialImplementList.filter(f => f.Id == m)

          if (arr.length > 0) {
            arr = arr.concat(filterUsingType)
          } else {
            arr = filterUsingType
          }

        })
        this.implementList = arr;
      } else {
        this.loadImplementsForEquipment()
      }

    }
  }

  onSelectRepairer() {
    if (this.selectedRepairer != null) {
      //this._equipmentId = this.selectedEquipment;
      //this.loadImplementsForEquipment();
    }
  }

  onImplementSelected() {

  }

  // Gets the list of implements that are currently loaded on the selected equipment.
  loadImplementsForEquipment() {



    this._fecrService.GetImplementsAvailable().subscribe(r => {
      console.log("r GetImplementsAvailable", r)
      console.log("r GetImplementsAvailable this.selectedImplementType", this.selectedImplementType)

      if (r) {
        if (this.selectedImplementType.length > 0) {
          let arr = []
          this.selectedImplementType.map(m => {
            let filterUsingType = r.filter(f => f.Id == m)

            if (arr.length > 0) {
              arr = arr.concat(filterUsingType)
            } else {
              arr = filterUsingType
            }

          })
          this.implementList = arr;
          this.initialImplementList = r
        } else {
          this.implementList = r;
          this.initialImplementList = r
        }

      }
    });
  }

  // Implement Makes
  loadMakes() {
    this._equipmentService.getMakeList().subscribe(r => {
      this.makeList = r;
    });

  }

  loadRepairer() {
    this._fecrService.getRepairerList().subscribe(r => {
      console.log("r getRepairerList", r)
      this.repairerList = r;
    });
  }

  loadFamilies() {
    this._fecrService.GetFamilyList().subscribe(r => {
      console.log("r GetFamilyList", r)
      this.familyList = r;
this.copyfamilyList =r;
    });
  }

  loadImplementTypes() {

    this._fecrService.getImplementTypeList().subscribe(r => {

      let arr = []

      if (this.selectedCustomer.length > 0 && r.length > 0) {



        r.map(m => {
          let check = this.selectedCustomer.find(f => f == m.CustomerId)
          if (check) {
            arr.push(m)
          }
        })
      } else {
        arr = r
      }


      this.implementTypeList = arr;
    });
  }


  loadModelList() {
    this.modelList = null
    var params: ModelSelectionFilter = {
      Families: this.selectedFamily,
      Makes: []
    }
    this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
      console.log("modelList", r)
      console.log("modelList params", params)

      if (r) {
        this.modelList = r;
      }
    });

  }

  arrStatus: number[] = [];
  submitSelection() {
    console.log("  this.arrStatus_before",  this.arrStatus)
    this.arrStatus = [];
    if (this.preShipped)
      this.arrStatus.push(1)
    if (this.shipped)
      this.arrStatus.push(2)
    if (this.disassembled)
      this.arrStatus.push(3)
    if (this.sow)
      this.arrStatus.push(4)
    if (this.approvals==true)
      this.arrStatus.push(5)
    if (this.wip)
      this.arrStatus.push(6)
    if (this.readytoShip)
      this.arrStatus.push(7)
    if (this.complete)
      this.arrStatus.push(8)
    if (this.readytoRebuild)
      this.arrStatus.push(0)

      console.log("  this.arrStatus_after",  this.arrStatus)
    var params: FECRDashboardSearch = {
      customers: this.selectedCustomer,
      jobsites: this.selectedJobsite,
      implementTypes: this.selectedImplementType,
      repairers: this.selectedRepairer,
      models: this.selectedModel,
      implements: this.selectedImplement,
      status: this.arrStatus,
      family: this.selectedFamily,
    }
    console.log("params", params)
    this.searchFilters.emit(params);

  }

  reset: boolean = false;
  ResetFields() {
    this.selectedCustomer = [];
    this.selectedCustomer = [];
    this.selectedRepairer = [];
    this.selectedImplementType = [];
    this.selectedJobsite = [];
    this.selectedFamily = [];
    this.selectedModel = [];
    this.selectedImplement = [];
    this.Reset.emit(this.reset);
  }


  OpenMovetoInventory(){
    const dialogRef = this.dialog.open(FecrMovetoInventoryComponent, {
      panelClass: 'removeModalOverflow',
      data: {
      }
    });

    dialogRef.afterClosed().subscribe(res => {
      if(res)
     this.submitSelection();

     else{
       
     }
    });
  }

  OpenCreteNewImplement(){
    //this._router.navigate(['setup/implement-new', _blabk]

    this._router.navigate([]).then(result => {  window.open('setup/implement-new', '_blank'); });
  }
}



